export default __webpack_public_path__ + "static/media/south-america-countries.c483702f.jpeg";